import Container from "@components/layout/Container";

const steps = [
	{
		num: "01",
		title: "Консультація",
		desc: "Телефонна або особиста зустріч. Обговорюємо побажання, розміри, бюджет і терміни.",
	},
	{
		num: "02",
		title: "Дизайн-проект",
		desc: "Наш художник розробляє індивідуальний макет і погоджує з вами кожну деталь",
	},
	{
		num: "03",
		title: "Виготовлення",
		desc: "Різьба, гравіювання, шліфовка — усе вручну на нашому виробництві в Ямполі.",
	},
	{
		num: "04",
		title: "Встановлення",
		desc: "Виїзд бригади, монтаж фундаменту та пам'ятника.",
	},
];

export default function HowWeWork() {
	return (
		<section className="how-we-work">
			<Container>
				<span className="eyebrow eyebrow--dark">Як ми працюємо</span>
				<h2 className="how-title">
					Чотири кроки до <span style={{color: "rgba(0, 71, 160, 1)", fontStyle: "italic"}}>готового</span> пам&apos;ятника
				</h2>

				<div className="how-grid">
					{steps.map((s) => (
						<div key={s.num} className="how-step">
							<div className="how-num">{s.num}</div>
							<h3 className="how-step-title">{s.title}</h3>
							<p className="how-step-desc">{s.desc}</p>
						</div>
					))}
				</div>
			</Container>
		</section>
	);
}
